/**
 * Résolution des URLs du backend de salles (docs/03 §9.3).
 * `VITE_WS_URL` est figé au build (`wss://…` en prod, `ws://localhost:8080` en dev).
 */

/** Base WebSocket, sans slash final. Vide si non configurée hors dev (multijoueur indisponible). */
export function wsBase(): string {
  const env = import.meta.env.VITE_WS_URL;
  if (env) return env.replace(/\/+$/, '');
  return import.meta.env.DEV ? 'ws://localhost:8080' : '';
}

/** Base HTTP dérivée (pour `POST /rooms`) : `ws→http`, `wss→https`. Vide si non configurée. */
export function httpBase(): string {
  const ws = wsBase();
  return ws ? ws.replace(/^ws/, 'http') : '';
}
